import { Machine } from "xstate";
import { handleCheckoutService } from "./services";
import { IContext, IEvent, ISchema } from "./types";

import {
  closePaymentSuccessfulModal,
  openPaymentSuccessfulModal,
  selectPaymentType,
  setHandleCheckoutResult,
  setUserEmail,
  setBackupPaymentData,
} from "./actions";

export const pricingMachine = Machine<IContext, ISchema, IEvent>(
  {
    id: "pricing",
    initial: "init",
    context: {
      paymentType: null,
      modalIsOpened: false,
      userEmail: "",
      hostedPageId: null,
      newUser: null,
      figmaPlanId: null,
      planQuantity: 50,
      isFigmaBackup: false,
    },
    states: {
      init: {
        always: [{ target: "payment" }],
      },
      payment: {
        on: {
          SELECT_PAYMENT_TYPE: {
            actions: "selectPaymentType",
            target: "checkout",
          },
          SET_USER_EMAIL: {
            actions: "setUserEmail",
          },
          SET_BACKUP_PAYMENT_DATA: {
            actions: "setBackupPaymentData",
            target: "checkout",
          },
        },
      },
      checkout: {
        invoke: {
          id: "handleCheckout",
          src: "handleCheckoutService",
          onDone: {
            actions: "setHandleCheckoutResult",
            target: "paymentSuccessful",
          },
          onError: "init",
        },
        on: {
          SELECT_PAYMENT_TYPE: {
            actions: "selectPaymentType",
            target: "checkout",
          },
          SET_BACKUP_PAYMENT_DATA: {
            actions: "setBackupPaymentData",
            target: "checkout",
          },
        },
      },
      paymentSuccessful: {
        entry: "openPaymentSuccessfulModal",
        on: {
          CLOSE_MODAL: {
            actions: "closePaymentSuccessfulModal",
            target: "payment",
          },
        },
      },
      error: {
        type: "final",
      },
    },
  },
  {
    actions: {
      selectPaymentType,
      setUserEmail,
      setHandleCheckoutResult,
      openPaymentSuccessfulModal,
      closePaymentSuccessfulModal,
      setBackupPaymentData,
    },
    services: {
      handleCheckoutService,
    },
  },
);
